import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


import { SessionService, TermApproval } from '@app/core';


@Injectable({
  providedIn: 'root',
})
export class TermsService {

  public redirect = '';

  constructor(
    private _sessionService: SessionService,
    private _router: Router,
    private _route: ActivatedRoute,
  ) { }

  public processTerms(termApproval: TermApproval) {
    const termsApproval = {
      ...this._sessionService.termsApproval,
      [termApproval]: false,
    };

    this._sessionService.termsApproval = termsApproval;
    this._router.navigate(['../terms'], { relativeTo: this._route });
  }

}
